export default "__VITE_ASSET__3Es2PF4Y__"